import { render, staticRenderFns } from "./TechBreak.vue?vue&type=template&id=466b0b0c&scoped=true&"
import script from "./TechBreak.vue?vue&type=script&lang=js&"
export * from "./TechBreak.vue?vue&type=script&lang=js&"
import style0 from "./TechBreak.vue?vue&type=style&index=0&id=466b0b0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "466b0b0c",
  null
  
)

export default component.exports